import "@/App.css";
import { LanguageProvider } from "./context/LanguageContext";
import LandingPage from "./pages/LandingPage";

function App() {
  return (
    <LanguageProvider>
      <LandingPage />
    </LanguageProvider>
  );
}

export default App;
